export const applyServerValue = (element, value) => {
  if (!(element instanceof HTMLSelectElement)) {
    return;
  }

  const target = `${value ?? ''}`;
  if (element.value === target) {
    return;
  }

  const match = Array.from(element.options).find((option) => option.value === target);
  Array.from(element.options).forEach((option) => {
    option.selected = match ? option === match : option === element.options[0];
  });
};
